<div class="component-container">
  @if (changeOrderFilter.length > 1) {
    <div
      #trigger="cdkOverlayOrigin"
      (click)="isOpen = true" cdkOverlayOrigin class="change-order-filter-button flex flex-row gap-[20px]"
      type="button"
      >
      <div class="label text-type-7 flex flex-row justify-between items-center"
        >
        <div
          class="pick-list-value"
          #selectedSpan
          [matTooltip]="selectedValue['order_number']"
          [matTooltipDisabled]="!isEllipsisActive(selectedSpan)"
          matTooltipPosition="above"
          matTooltipClass="co-filter-tooltip white-tooltip"
          >
          {{ selectedValue['order_number'] }}
        </div>
        @if (selectedValue['key'] !== -1) {
          <div
            class="current ml-[5px] text-[#60698B]"
            >
            ({{ selectedValue['created_at'] | date :'mediumDate' }})
          </div>
        }
      </div>
      <mat-icon
        [ngClass]="{'rotate': isOpen}"
        class="dropdown-icon"
        svgIcon="chevron-down"
        />
    </div>
    <ng-template
      (backdropClick)="isOpen = false"
      [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayOpen]="isOpen"
      [cdkConnectedOverlayOrigin]="trigger"
      cdkConnectedOverlay
      >
      <div class="change-order-filter-popup">
        <div class="change-order-filter-list">
          @for (eachChangeOrder of changeOrderFilter; track eachChangeOrder; let i = $index) {
            <div
              (click)="changeOrderFilterItemClicked(eachChangeOrder)"
              class="change-order-filter-item"
              >
              <div class="flex flex-col justify-center">
                @if (eachChangeOrder['order_number']) {
                  <div
                    [ngClass]="{'selected-filter-option': selectedValue['id'] === eachChangeOrder['id']}"
                    class="pick-list-option-value text-type-11"
                    #optionSpan
                    [matTooltip]="eachChangeOrder['order_number']"
                    [matTooltipDisabled]="!isEllipsisActive(optionSpan)"
                    matTooltipPosition="above"
                    matTooltipClass="co-filter-tooltip white-tooltip"
                    >
                    {{ eachChangeOrder['order_number'] }}
                  </div>
                }
                @if (eachChangeOrder['key'] !== -1) {
                  <div class="text-type-10">
                    ({{ eachChangeOrder['created_at'] | date :'mediumDate' }})
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>
  }

  <form class="flex flex-col gap-[calc(40px-1.25em)]">
    <app-view-field
      [value]="form?.controls['unitPrice']?.value"
      label="Unit Price"
      />

    <app-view-field
      [value]="form?.controls['totalQuantity']?.value"
      label="Total Quantity"
      />

    <app-view-field
      [value]="form?.controls['desc']?.value"
      label="Description"
      />

    <app-view-field
      [value]="form?.controls['uom']?.value"
      label="Uom"
      />

    @for (site of iterableSitesList; track site; let i = $index) {
      <app-view-field
        [label]="site.name || site.site_name"
        [value]="form?.controls?.[site.name || site.site_name]?.value"
        />
    }
  </form>
</div>
